module.exports = __webpack_public_path__ + "static/media/outfit10.90fa0d8c.jpg";